import { render, staticRenderFns } from "./drCpmDetail.vue?vue&type=template&id=54abb20a&scoped=true"
import script from "./drCpmDetail.vue?vue&type=script&lang=js"
export * from "./drCpmDetail.vue?vue&type=script&lang=js"
import style0 from "./drCpmDetail.vue?vue&type=style&index=0&id=54abb20a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54abb20a",
  null
  
)

export default component.exports